export default __webpack_public_path__ + "static/media/logodaj.e5784209.svg";